var texts = {
    en: {
        dataTable: {
            purchaseDate: 'Purchase date',
            provider: 'Beneficiary',
            invoice: 'Invoice',
            totalAmount: 'Total amount',
            creditPeriod: 'Credit period',
            dueDate: 'Due date',
            exchangeRateProtection: 'Exchange rate protection',
            exchangeRateToday: 'Exchange rate today',
            currencyProfit: 'Profit (%)',
            totalProtectedUsd: 'Total protected (USD)',
            totalUsdToday: 'Total USD today',
            currencyGain: 'Currency gain',
            currencyProfitUsd: 'Currency profit (USD)',
            actions: 'Actions',
            quote: 'Quote',
            status: 'Status',
            add: 'Add',
            addFounds: 'Add founds',
            edit: 'Edit',
            receipt: 'Receipt',
        },
        modalForm: {
            textTitle: 'Modify',
            purchaseDate: 'Purchase date',
            salesDate: 'Sales date',
            provider: 'Beneficiary',
            invoice: 'Invoice',
            totalAmount: 'Total amount',
            creditPeriod: 'Credit period',
            dueDate: 'Due date',
            exchangeRateProtection: 'Exchange rate protection',
            currencyProfit: 'Currency profit (%)',
            currencyProfitUsd: 'Currency profit (USD)',
            totalProtectedUsd: 'Total protected (USD)',
            currencyGain: 'Currency gain',
            exchangeRateToday: 'Exchange rate today',
            totalUsdToday: 'Total USD today',
            adjust: 'Adjust',
            confirm: 'Confirm',
            confirmPay: 'Confirm payment',
            confirmCollect: 'Confirm collection',
            confirmConvert: 'Confirm conversion',
            confirmForward: 'Confirm forward',
            continue: 'Continue',
            cancel: 'Cancel',
            save: 'Save',
            return: 'Return',
            requestPayment: 'Request payment',
            createSupplier: 'Create beneficiary',
            createClient: 'Create client',
            validate: 'Validate',
            delete: 'Delete',
        },
        textTitle: 'Modify',
        textTitleSepare: 'Quote',
        textTitleCreate: 'Create',
        register: {
            register: 'Register',
            sBankName: 'Bank name',
            sAccountNumber: 'Account number',
            sRoutingNumber: 'Routing number',
            clabe: 'Clabe',
            sBankNameMxn: 'Bank name (MXN)',
        },
        registerProvider: {
            email: 'Email',
            name: 'Name',
            country: 'Country',
            bank_name: 'Bank name',
            clabe: 'Clabe number',
        },
        status: {
            TO_PAY: 'To pay',
            COMPLETED: 'Paid',
            SEPARATED: 'Separated',
            WAITING_FOR_DEPOSIT: 'Waiting for deposit',
            VALIDATION_AMOUNT: 'Amount validation',
            REJECTED: 'Rejected',
            PENDING_TO_PROCESS: 'Processing',
            PENDING_TO_DEPOSIT: 'Pending to deposit',
            DEPOSITED: 'Deposited',
            PROCESSING: 'Processing',
            UNKNOWN_STATUS: 'Unknown status',
            PENDING_TO_PROCESS_SCHEDULED_PAYMENT: 'Pending to process scheduled payment',
        },
        payments: {
            payNow: 'Pay Now',
            payNowDescription: 'Use your account balance',
            paySeparate: 'Convert payment to MXN',
            paySeparateDescription: "Convert your USD to MXN, then choose when to pay your beneficiary",
            payDeferred: 'Deferred Payment',
            payDeferredDescription: 'Lock an exchange rate, then pay via bank transfer',
            payForward: 'Forward Payment',
            payForwardDescription: 'Guard against exchange rate fluctuations',
        },
        menu: {
            home: 'Home',
            operation: 'Operation',
            history: 'History',
            wallets: 'Contacts',
            compliance: 'Compliance',
            financiamiento: 'Factoring',
            fleteClient: 'Freigth Perlag',
            fleteTransport: 'Freigth Fletero',
            providers: 'Providers',
            settings: 'Settings',
        },
        subMenu: {
            dashboard: 'Dashboard',
            history: 'Invoice control',
            activeForwards: 'Active conversions',
            activeForwardsMX: 'Active conversions',
            balance: 'Available conversions',
            collection: 'Collection History',
            historyIn: 'Deposit History',
            historyConversion: 'Conversion History',
            historyConversionMX: 'Conversion History',
            historyOut: 'Payment History',
            fletero: 'Freights',
            calendarioFletero: 'Calendar',
            suppliers: 'Beneficiary',
            clients: 'Clients',
            contracts: 'Contracts',
            statement: 'Statement',
            calendar: 'Calendars',
            security: 'Security',
            payments: 'Historial de pagos',
            collection: 'Historial de cobros',
            invoices: 'Facturas',
            calendarTraditional: 'Calendar',
            facturasPorPagar: 'Facturas por pagar',
            facturaFlete: 'Facturas de Flete',
        },
        twoFactor: {
            twoFactor: 'Two-factor authentication',
            enterCode: 'Please enter the 6-digit code sent to your email to confirm the transaction. The code will expire in 10 minutes.',
        },
        dashboard: {
            welcomeTitle: 'Hi, ',
            dashboardDescription: 'Pay your invoices and add funds when you want.',
            exchangeRateActual: 'Actual exchange rate',
            exchangeRateTodayDescription: 'Exchange rate will update in',
            seconds: 'seconds',
            usdBalance: 'USD Balance',
            account: 'Your account',
            blockedAmount: 'Blocked amount forwards:',
            addFounds: 'Add funds',
            addFoundsDetail: 'Detail',
            mxnBalance: 'MXN Balance',
            sendPay: 'Send payment',
            sendPayMassive: 'Massive payment',
            collectionPay: 'Withdrawal',
            sendPayDetail: 'Select the contact you wish to send the payment to.',
            contacts: 'Contacts',
            transferMoney: 'Transfer money',
            client: 'Client',
            balanceAccount: 'Account balance',
            amountToSend: 'How much do you want to send?',
            amountToConvert: 'Amount to convert',
            totalConverted: 'Total converted',
            exchangeRate: 'Exchange rate',
            sendAmount: 'How much would you like to send?',
            hintText: 'You can only convert ${amount} USD.',
            toMexicanPesos: 'To Mexican pesos',
            toUSDDollars: 'To USD Dollars',
            clientName: 'Client name',
            clabeNumber: 'CLABE number',
            destinationReceives: 'The recipient will receive',
            sendDate: 'Send date',
            paymentConcept: 'Payment concept',

            convert: 'Convert',
            convertAmount: 'Convert the amount you want to a different currency.',
            fromUsdDollars: 'From USD Dollars',
            fromMXNPesos: 'From MXN pesos',
            selectDateForward: 'Select the date of your forward',
            forward: 'Forward',
            buyForward: 'Buy a forward',
            forwardConditions: 'To schedule a future payment, you must meet the following two conditions:',
            forwardConditions1: 'The selected date is the date in which the scheduled payment will be executed. The funds must be loaded before the end of the period.',
            forwardConditions2: 'You will need to make a deposit of 5% of the total Forward funds, which will be deducted from your USD balance.',
            forwardDetail: 'Forward detail',
            amountToReceive: 'Amount to receive in your account:',
            scheduledDate: 'Scheduled date:',
            forwardPercentage: '5% of the total Forward funds',
            forwardConditions3: 'Please load the corresponding funds before or on the due date',
            forwardConditions3TextPart1: 'If the payment does not have the funds for the date indicated: ',
            forwardConditions3TextPart2: 'In case of not meeting the payment of the scheduled operation, the differential between the exchange rate of that date and the initially scheduled rate will have to be covered.',

            pendingInvoices: 'Pending invoices to assign',
            availableConversions: 'Available conversions',
            activeForwards: 'Active conversions',
            activeForwardsMX: 'Active conversions',
            massivePayments: 'Massive payments',
            logout: 'Logout',
            version: 'Version',
            allRightsReserved: 'All rights reserved',
            forwardTime: 'The forwards can only be processed between 9 a.m. and 2 p.m. (CDMX, GMT-6), by banking hours',
            payForwardDescriptionDisabled: 'The forwards can only be processed between 9 a.m. and 2 p.m. (CDMX, GMT-6), by banking hours',
            bankingTime: 'CDMX, GMT-6 time',
            localTime: 'Local time',
            createAlerts: 'Create price alert',
            priceAlerts: 'Price alerts',
            createAlert: 'Create alert',
            notifyMeToSellUSD: 'Notify me to sell USD',
            targetPrice: 'Target Price',
            alertCancel: 'Cancel',
            alertCreate: 'Create',
        },
        invoices: {
            title: 'Pending invoices',
            subTitle: 'Here you will find your invoices that have not been assigned the exchange rate and are pending to be assigned.',
            exchangeRateActual: 'Actual exchange rate',
            exchangeRateTodayDescription: 'Exchange rate will update in',
            seconds: 'seconds',
            invoicePendingToAssign: 'Invoice pending to assign',
            selectSupplier: 'Select beneficiary',
            selectClient: 'Select client',
            selectStatus: 'Select the status',
            addInvoice: 'Add invoice',
            pay: 'Pay',
            collect: 'Collect',
            convert: 'Convert',
            supplier: 'Beneficiary',
            purchaseDate: 'Purchase date',
            salesDate: 'Sales date',
            dueDate: 'Due date',
            invoice: 'Invoice',
            status: 'Status',
            avaible: 'Avaible payment',
            totalAmountMXN: 'Total amount MXN',
            rateProtection: 'Exchange rate protection MXN',
            profitPercentage: 'Profit (%)',
            currencyGain: 'Currency gain',
            actions: 'Actions',
            selectId: 'Search invoice',
            totalCurrencyGain: 'Total currency gain',
            //Add invoice
            addInvoice: 'Add invoice',
            addInvoiceDetail: 'Add invoice detail',
            addInvoiceDetailText: 'Add the following information to add a new invoice.',
            invoice: 'Invoice',
            supplier: 'Beneficiary',
            client: 'Client',
            purchaseDate: 'Purchase date',
            salesDate: 'Sales date',
            totalAmountMXN: 'Total amount MXN',
            totalAmountUSD: 'Total amount USD',
            creditTime: 'Credit time',
            exchangeRateProtected: 'Exchange rate protected',
            requiredField: '*indicates required field',
            paymentDetail: 'Payment detail',
            collectDetail: 'Collection detail',
            customerName: 'Beneficiary name',
            clientName: 'Client name',
            clabe: 'CLABE number',
            amountToSend: 'Amount to send',
            destinationReceives: 'The recipient will receive',
            exchangeRate: 'Exchange rate',
            invoiceToPay: 'Invoice to pay',
            invoiceToCollect: 'Invoice to collect',
            sendDate: 'Send date',
            selectTypeConversion: 'Select the type of conversion',
            selectTypeOfWallet: 'Select the wallet from which you want the funds to be withdrawn.',
            selectTypeOfWalletPay: 'Select the wallet from which you want to use the funds.',
            selectTypeOfCollect: 'Select the destination where you want the funds to go.',
            conversionDetail: 'Conversion detail',
            invoiceToConvert: 'Invoice to convert',
            amountToReceive: 'Amount to receive in your account',
            exchangeRate: 'Exchange rate',
            convert: 'Convert',
            selectDate: 'Select the date of your forward',
            forwardDetail: 'Forward detail',
            forwardConditions: 'To schedule a future payment, you must meet the following two conditions:',
            forwardConditions1: 'The selected date is the date in which the scheduled payment will be executed. The funds must be loaded before the end of the period.',
            forwardConditions2: 'You will need to make a deposit of 5% of the total Forward funds, which will be deducted from your USD balance.',
            forwardConditions3: 'Please load the corresponding funds before or on the due date',
            forwardConditions4: 'If the payment does not have the funds for the date indicated',
            forwardConditions5: 'In case of not meeting the payment of the scheduled operation, the differential between the exchange rate of that date and the initially scheduled rate will have to be covered.',
            forwardConditions6: 'You will have to pay a deposit of 5% of the total funds of the Forward right now, the amount to deposit is',
            forwardConditions7: 'the amount will be deducted from your USD balance',
            download: 'Download',
            editInvoice: 'Edit invoice',
            invoiceDeleteTitle: 'Are you sure you want to delete the invoice?',
            invoiceDeleteMessage: 'Once you delete the invoice, you will not be able to recover it.',
            sId: "Purchase Order",
            invoiceDuplicateTitle: 'Important notice',
            invoiceDuplicateSubtitle: 'A similar invoice to the one you are trying to add was found, do you want to continue?',
            amountError: 'The amount must be greater than 5% of the total amount.',
        },
        conversions: {
            avaibleConversion: 'Available conversion',
            title: 'Available conversions',
            description: 'Here you will find your available conversions to execute payments.',
            balance: 'MXN Balance',
            avaible: 'Available amount',
            assigned: 'Converted amount',
            totalCurrencyGain: 'Total currency gain',
            pay: 'Pay',
            collect: 'Collect',
            id: 'Id',
            transactionDate: 'Transaction date',
            typeTransaction: 'Type transaction',
            targetAccount: 'Target Account',
            dueDate: 'Due date',
            missingDays: 'Missing days',
            totalAmountUSD: 'Total origin amount',
            totalAmountMXN: 'Total dest amount',
            exchangeRate: 'Exchange rate',
            invoice: 'Invoice',
            supplier: 'Beneficiary name',
            purchaseDate: 'Purchase date',
            currencyProfit: 'Profit ($)',
            dollarProfit: 'Profit (%)',
            actions: 'Actions',
            percentAssigned: '% Assigned',
            selectContact: 'Select the contact to whom you want to send the payment.',
            contacts: 'Contacts',
            paymentDetail: 'Payment detail',
            collectDetail: 'Collection detail',
            clientName: 'Client name',
            clabe: 'CLABE number',
            amountToSend: 'Amount to send',
            destinationReceives: 'The recipient will receive',
            exchangeRate: 'Exchange rate',
            invoiceToPay: 'Invoice to pay',
            invoiceToCollect: 'Invoice to collect',
            sendDate: 'Send date',
            paymentConcept: 'Payment concept',
            detail: 'Detail of the conversion',

            conversionDetailTitle: 'Conversion detail',
            conversionDetailSubTitle: 'Here you will find the detail of the conversion of the selected invoice.',
            conversionDetailType: 'Type',
            conversionDetailAmount: 'Amount',
            conversionDetailProfit: 'Profit',
            conversionDetailProvider: 'Beneficiary: ',
            conversionDetailExchangeRate: 'Exchange rate',
            conversionDetailDate: 'Creation date',
            conversionDetailDateEnd: 'Date of fulfillment',
            conversionDetailPercent: 'Percentage of the conversion used',
            conversionDetailInvoices: 'Assigned invoices',
            conversionDetailSupplier: 'Beneficiary name',
            conversionDetailAddInvoices: 'Add invoices',
            conversionDetailInvoice: 'Invoice',
            conversionDetailEditInvoice: 'Modify invoice',
            conversionDetailDeleteInvoice: 'Delete invoice from conversion',
            conversionDetailDatePurchase: 'Purchase date',
            conversionDetailExchangeRateProtected: 'Exchange rate protected',
            conversionDetailConfirmPayment: 'Are you sure you want to request the total payment of the forward?',
            conversionDetailMessage: 'Once you make the transaction, it will be reviewed that your USD balance is sufficient to pay the total amount of the forward.',
            conversionDetailMessage2: 'The amount will go to the Available balance MXN tab.',
            editForward: 'Edit forward',
            requestPayment: 'Request payment',
            payInvoices: 'Pay invoices',
            paymentDate: 'Payment date',
            cobroDate: 'Collection date',
            recipient: 'Recipient',
            client: 'Client',
            download: 'Download',
            status: 'Payment status',
        },
        activeForwards: {
            title: 'Active conversions',
            subTitle: 'Here you will find your active forwards that are pending to be executed.',
            usdBalance: 'USD Balance',
            blockedAmount: 'Blocked amount forwards',
            totalCurrencyGain: 'Total currency gain',
            dueDate: 'Due date',
            missingDays: 'Missing days',
            totalAmountUSD: 'Total origin amount',
            totalAmountMXN: 'Total dest amount',
            exchangeRate: 'Exchange rate',
            currencyProfit: 'Currency profit',
            supplier: 'Beneficiary',
            actions: 'Actions',
            invoice: 'Invoice',
            purchaseDate: 'Purchase date',
            dollarProfit: 'Currency profit',
            id: 'Id',
            transactionDate: 'Transaction date',
            typeTransaction: 'Type transaction',
            targetAccount: 'Target Account',
            conversionDetailTitle: 'Conversion detail',
            conversionDetailSubTitle: 'Here you will find the detail of the conversion of the selected invoice.',
            conversionDetailType: 'Type',
            conversionDetailAmount: 'Amount',
            conversionDetailProfit: 'Profit',
            conversionDetailProvider: 'Beneficiary: ',
            conversionDetailExchangeRate: 'Exchange rate',
            conversionDetailDate: 'Creation date',
            conversionDetailDateEnd: 'Date of fulfillment',
            conversionDetailPercent: 'Percentage of the conversion used',
            conversionDetailInvoices: 'Assigned invoices',
            conversionDetailSupplier: 'Beneficiary name',
            conversionDetailAddInvoices: 'Add invoices',
            conversionDetailInvoice: 'Invoice',
            conversionDetailEditInvoice: 'Modify invoice',
            conversionDetailDeleteInvoice: 'Delete invoice from conversion',
            conversionDetailDatePurchase: 'Purchase date',
            conversionDetailExchangeRateProtected: 'Exchange rate protected',
            conversionDetailConfirmPayment: 'Are you sure you want to request the total payment of the forward?',
            conversionDetailMessage: 'Once you make the transaction, it will be reviewed that your USD balance is sufficient to pay the total amount of the forward.',
            conversionDetailMessage2: 'The amount will go to the Available balance MXN tab.',
            editForward: 'Edit forward',
            requestPayment: 'Request payment',
            download: 'Download',
            purchaseOrder: 'Purchase Order',
            forwardsAmountPendingGood: 'Don\'t have forwards pending to be executed in the next 5 days',
            forwardsAmountPendingAlert: 'You have forwards pending to be executed in the next 5 days, the total amount is',
            amountRemainingUSD: 'Amount remaining',
        },
        conversionsHistory: {
            title: 'Conversion history',
            subTitle: 'Here you will find the history of all your conversions.',
            totalCurrencyGain: 'Total currency gain',
            viewDetail: 'View detail',
            download: 'Download',
            detail: 'Detail of conversion',
            type: 'Type',
            amount: 'Amount',
            exchangeRate: 'Exchange rate',
            creationDate: 'Creation date',
            completionDate: 'Completion date',
            percentageConversionPaid: 'Percentage of conversion paid',
            payments: 'Payments made',
            paymentDate: 'Payment date',
            cobroDate: 'Collection date',
            recipient: 'Recipient',
            invoice: 'Invoice',
            noPayments: 'No payments made',
            percentageConversionUsed: 'Percentage of conversion used',
            invoicesAssigned: 'Invoices assigned',
            invoiceDetail: 'Invoice detail',
            purchaseDate: 'Purchase date',
            exchangeRateProtected: 'Exchange rate protected',
            profitPercent: 'Profit (%)',
            profit: 'Profit',
            noInvoicesAssigned: 'No invoices assigned',
        },
        paymentsHistory: {
            title: 'Payment history',
            subTitle: 'Here you will find the history of all your payments.',
            totalCurrencyGain: 'Total currency gain',
            viewDetail: 'View detail',
            download: 'Download',
            invoices: 'Invoices',
        },
        suppliers: {
            title: 'Beneficiary',
            titleClient: 'Clients',
            subTitle: 'Here you will manage all your beneficiaries.',
            subTitleClient: 'Here you will manage all your clients.',
            addSupplier: 'Add beneficiary',
            addClient: 'Add client',
            name: 'Name',
            email: 'Email',
            country: 'Country',
            entityBusiness: 'Entity type',
            entityBusinessCompany: 'Company',
            entityBusinessPerson: 'Person',
            firstName: 'First name',
            lastName: 'Last name',
            bankName: 'Bank name',
            currencyAccount: 'Currency account',
            accountNumber: 'Clabe number',
            taxId: 'RFC',
            actions: 'Actions',
            editSupplier: 'Edit beneficiary',
            deleteSupplier: 'Delete beneficiary',
            detailSupplier: 'Contact detail',
            details: 'See details',
            //Create supplier
            createSupplier: 'Create beneficiary',
            createClient: 'Create client',
            requiredField: '*indicates required field',
            //Edit supplier
            editSupplier: 'Edit beneficiary',
            download: 'Download'
        },
        clients: {
            title: 'Clients',
            subTitle: 'Here you will manage all your clients',
            addSupplier: 'Add client',
            addClient: 'Add client',
            name: 'Name',
            email: 'Email',
            country: 'Country',
            bankName: 'Bank name',
            accountNumber: 'Account number',
            taxId: 'RFC',
            actions: 'Actions',
            editSupplier: 'Edit client',
            deleteSupplier: 'Delete client',
            //Crear Beneficiario
            createClient: 'Create client',
            requiredField: '*indicates required field',
            //Editar Beneficiario
            editSupplier: 'Edit client',
            download: 'Download'
        },
        settings: {
            title: 'Hi ',
            subtitle: 'Secure your account. Manage your account settings and define user roles',
            emailTwoFactor: {
                title: 'Email two factor',
                subtitle: 'Secure your account. Enter your new email to protect your account with 2FA.',
                buttonText: 'Configure',
                editEmailTitle: 'Update email',
                editEmailSubtitle: 'Enter your new email to protect your account with 2FA.',
                currentEmail: 'Current email',
                newEmail: 'New email',
                cancel: 'Cancel',
                continue: 'Continue',
                configureEmailTitle: 'Configure email',
                configureEmailSubtitle: 'Enter your new email to protect your account with 2FA.',
                configureEmailEmail: 'Email',
                configureEmailPassword: 'Current password',
                configureEmailSave: 'Save',
                twoFactor: {
                    title: 'Two factor authentication',
                    subtitle: 'We have sent a code to your previous email. Enter it to continue.',
                    validate: 'Validate',
                    cancel: 'Cancel',
                }
            },
            resetPassword: {
                title: 'Reset password',
                subtitle: 'To reset your password, you need to enter the verification code that we will send to your email.',
                buttonText: 'Reset password',
                resetPasswordTitle: 'Reset password',
                resetPasswordSubtitle: 'Enter your new password and confirm it to continue.',
                resetPasswordNewPassword: 'New password',
                resetPasswordConfirmPassword: 'Confirm password',
                continue: 'Continue',
                cancel: 'Cancel',
                twoFactor: {
                    title: 'Two factor authentication',
                    subtitle: 'Please enter the 6-digit code sent to your email to confirm the transaction. The code will expire in 10 minutes.',
                    validate: 'Validate',
                    cancel: 'Cancel',
                }
            },
            users: {
                title: 'Users',
                subtitle: 'Manage and create new users for your account.',
                buttonText: 'Manage',
                name: 'Name',
                lastname: 'Lastname',
                email: 'Email',
                status: 'Status',
                actions: 'Actions',
                edit: 'Edit',
                delete: 'Delete',
                addUser: 'Add user',
                active: 'Active',
                inactive: 'Inactive',
                disableUserTooltip: 'Disable user',
                confirmDeleteTitle: 'Are you sure you want to disable the user?',
                confirmDeleteText: 'Once the user is disabled, they will not be able to access the platform.',
                confirmDeleteCancel: 'Cancel',
                confirmDeleteDisable: 'Disable',
                password: 'Password',
                confirmPassword: 'Confirm Password',
                continue: 'Continue',
                cancel: 'Cancel',
                validate: 'Validate',
                otpTitle: 'Two-factor authentication',
                otpDescription: 'Please enter the 6-digit code sent to your email to confirm the transaction. The code will expire in 10 minutes.',
                nameRequired: 'Name is required',
                lastnameRequired: 'Lastname is required',
                emailRequired: 'Email is required',
                emailValid: 'Email is not valid',
                passwordRequired: 'Password is required',
                passwordLength: 'Password must be at least 6 characters',
                confirmPasswordRequired: 'Confirm password is required',
                confirmPasswordMatch: 'Passwords do not match',
                otpRequired: 'OTP is required',
                otpLength: 'OTP must be 6 digits',
                passwordSpecialCharacters: 'Password must have at least one special character',
                passwordCurrent: 'Current password',
                passwordNew: 'New password',
                passwordConfirm: 'Confirm password',
                passwordCurrentRequired: 'Current password is required',
                passwordNewRequired: 'New password is required',
                passwordConfirmRequired: 'Confirm password is required',
                passwordConfirmMatch: 'Passwords do not match',
            },
            accountStatement: {
                title: 'Account statement',
                subtitle: 'Here you will find your available account statements.',
                buttonText: 'Request',
            },

        },
        incomes: {
            id: 'ID',
            sPayerName: 'Payer name',
            title: 'Deposit history',
            subTitle: 'Here you will find the history of all your incomes.',
            download: 'Download',
            incomeDate: 'Deposit date',
            amountUsd: 'Amount USD',
        },
        statements: {
            title: 'Statement',
            month: 'Month',
            subtitle: 'Here you will find your available account statements.'
        },
        calendars: {
            title: 'Calendars',
            subtitle: 'Track Your Payment Due Dates.'
        }
    },
    sp: {
        dataTable: {
            purchaseDate: 'Fecha de compra',
            provider: 'Beneficiario',
            invoice: 'Factura',
            totalAmount: 'Monto total',
            creditPeriod: 'Plazo de crédito',
            dueDate: 'Fecha de vencimiento',
            exchangeRateProtection: 'Protección de tipo de cambio',
            exchangeRateToday: 'Tipo de cambio hoy',
            currencyProfit: 'Ganancia de moneda (%)',
            currencyProfitUsd: 'Ganancia de moneda (USD)',
            totalProtectedUsd: 'Total protegido (USD)',
            totalUsdToday: 'Total USD hoy',
            currencyGain: 'Ganancia de moneda',
            actions: 'Acciones',
            quote: 'Cotizar',
            status: 'Estado',
            add: 'Agregar',
            addFounds: 'Agregar fondos',
            edit: 'Editar',
            receipt: 'Recibo',
        },
        modalForm: {
            textTitle: 'Modificar',
            purchaseDate: 'Fecha de compra',
            salesDate: 'Fecha de venta',
            provider: 'Beneficiario',
            invoice: 'Factura',
            totalAmount: 'Monto total',
            creditPeriod: 'Plazo de crédito',
            dueDate: 'Fecha de vencimiento',
            exchangeRateProtection: 'Protección de tipo de cambio',
            currencyProfit: 'Ganancia de moneda (%)',
            currencyProfitUsd: 'Ganancia de moneda (USD)',
            totalProtectedUsd: 'Total protegido (USD)',
            currencyGain: 'Ganancia de moneda',
            exchangeRateToday: 'Tipo de cambio hoy',
            totalUsdToday: 'Total USD hoy',
            adjust: 'Ajustar',
            confirm: 'Confirmar',
            confirmPay: 'Confirmar pago',
            confirmCollect: 'Confirmar cobro',
            confirmConvert: 'Confirmar conversión',
            confirmForward: 'Confirmar forward',
            continue: 'Continuar',
            cancel: 'Cancelar',
            save: 'Guardar',
            return: 'Regresar',
            requestPayment: 'Solicitar pago',
            createSupplier: 'Crear beneficiario',
            createClient: 'Crear cliente',
            validate: 'Validar',
            delete: 'Eliminar',
        },
        textTitle: 'Modificar',
        textTitleSepare: 'Cotizar',
        textTitleCreate: 'Crear',
        register: {
            register: 'Registrar',
            sBankName: 'Nombre del banco',
            sAccountNumber: 'Número de cuenta',
            sRoutingNumber: 'Número de ruta',
            clabe: 'Clabe',
            sBankNameMxn: 'Nombre del banco (MXN)',
        },
        registerProvider: {
            email: 'Email',
            name: 'Nombre',
            bank_name: 'Nombre del banco',
            clabe: 'Número de clabe',
        },
        status: {
            TO_PAY: 'Por pagar',
            COMPLETED: 'Pagado',
            SEPARATED: 'Separado',
            WAITING_FOR_DEPOSIT: 'Esperando depósito',
            VALIDATION_AMOUNT: 'Validación de monto',
            REJECTED: 'Rechazado',
            PROCESSING: 'Procesando',
            PENDING_TO_DEPOSIT: 'Pendiente de depositar',
            DEPOSITED: 'Depositado',
            PENDING_TO_PROCESS: 'Procesando',
            UNKNOWN_STATUS: 'Estado desconocido',
            PENDING_TO_PROCESS_SCHEDULED_PAYMENT: 'Pendiente de procesar pago programado',
        },
        payments: {
            payNow: 'Pagar Ahora',
            payNowDescription: 'Utiliza tu saldo',
            paySeparate: 'Convierte pago a MXN',
            paySeparateDescription: "Convierte tus USD a MXN, luego decide cuándo pagar a tu beneficiario",
            payDeferred: 'Pago Diferido',
            payDeferredDescription: 'Asegura un tipo de cambio, después paga por transferencia',
            payForward: 'Pago a Futuro',
            payForwardDescription: 'Protégete de fluctuaciones cambiarias',
        },
        menu: {
            home: 'Inicio',
            operation: 'Operación',
            history: 'Historial',
            wallets: 'Contactos',
            compliance: 'Compliance',
            financiamiento: 'Factoring',
            fleteClient: 'Freigth Perlag',
            fleteTransport: 'Freigth Fletero',
            providers: 'Beneficiarios',
            settings: 'Ajustes',
        },
        subMenu: {
            dashboard: 'Dashboard',
            history: 'Control de facturas',
            activeForwards: 'Conversiones activas',
            activeForwardsMX: 'Conversiones activas',
            balance: 'Conversiones disponibles',
            collection: 'Historial de cobros',
            historyIn: 'Historial de ingresos',
            historyConversion: 'Historial de conversiones',
            historyConversionMX: 'Historial de conversiones',
            historyOut: 'Historial de egresos',
            suppliers: 'Beneficiarios',
            clients: 'Clientes',
            contracts: 'Contratos',
            statement: 'Estado de cuenta',
            security: 'Seguridad',
            calendarTraditional: 'Calendario',
            calendar: 'Calendarios',
            payments: 'Historial de pagos',
            collection: 'Historial de cobros',
            invoices: 'Facturas',
            fletero: 'Freights',
            calendarioFletero: 'Calendar',
            facturasPorPagar: 'Facturas por pagar',
            facturaFlete: 'Facturas de Flete',
        },
        twoFactor: {
            twoFactor: 'Autenticación de dos factores',
            enterCode: 'Por favor, ingresa el código de 6 dígitos que se ha enviado a tu email para confirmar la transacción. El código expirará en 10 minutos.',
        },
        dashboard: {
            welcomeTitle: '¡Hola, ',
            dashboardDescription: 'Paga tus facturas y añade fondos cuando quieras.',
            exchangeRateActual: 'Tipo de cambio actual',
            exchangeRateTodayDescription: 'Tipo de cambio se actualizará en',
            seconds: 'segundos',
            usdBalance: 'Balance USD',
            account: 'Tu cuenta bancaria',
            blockedAmount: 'Monto bloqueado forwards:',
            addFounds: 'Añadir fondos',
            addFoundsDetail: 'Detalle',
            mxnBalance: 'Balance MXN',
            sendPay: 'Enviar pago',
            sendPayMassive: 'Pago masivo',
            collectionPay: 'Retiro',
            sendPayDetail: 'Selecciona el contacto al que quieres enviar el pago.',
            contacts: 'Contactos',
            transferMoney: 'Transferir dinero',
            client: 'Cliente',
            balanceAccount: 'Saldo de la cuenta',
            totalConverted: 'Total convertido',
            amountToSend: '¿Cuánto quieres enviar?',
            amountToConvert: 'Monto a convertir',
            exchangeRate: 'Tipo de cambio',
            sendAmount: '¿Cuánto quieres enviar?',
            hintText: 'Usted solo puede convertir ${amount} USD.',
            toMexicanPesos: 'A Pesos Mexicanos',
            toUSDDollars: 'A USD Dolares',
            clientName: 'Nombre del cliente',
            clabeNumber: 'Nmero CLABE',
            destinationReceives: 'El destinatario recibirá',
            sendDate: 'Fecha de envío',
            paymentConcept: 'Concepto de pago',

            convert: 'Convertir',
            convertAmount: 'Convierte la cantidad que quieras a una moneda diferente.',
            fromUsdDollars: 'De USD Dolares',
            fromMXNPesos: 'De MXN pesos',
            exchangeRate: 'Tipo de cambio',

            forward: 'Pago futuro',
            buyForward: 'Comprar un forward',
            forwardConditions: 'Para programar un futuro pago, debes cumplir con las siguientes dos condiciones:',
            forwardConditions1: 'La fecha seleccionada es la fecha en la cual se ejecutara el pago pactado. La carga de fondos debe efectuarse previo al fin del plazo.',
            forwardConditions2: 'Tendrás que hacer un deposito del 5% de los fondos totales del Futuro, los cuales serán restados de tu balance USD.',
            forwardDetail: 'Detalle del forward',
            amountToReceive: 'Monto a recibir en tu cuenta:',
            scheduledDate: 'Fecha programada:',
            forwardPercentage: '5% de los fondos totales del Futuro',
            forwardConditions3: 'Por favor carga los fondos correspondientes antes o en la fecha del vencimiento',
            forwardConditions3TextPart1: 'Si el pago no cuenta con los fondos para la fecha indicada: ',
            forwardConditions3TextPart2: 'En caso de no cumplir con el pago de la operación pactada, se deberá cubrir el diferencial entre la tipo de cambio de esa fecha y la pactada inicialmente.',


            pendingInvoices: 'Facturas pendientes de asignar',
            availableConversions: 'Conversiones disponibles',
            activeForwards: 'Conversiones activas',
            activeForwardsMX: 'Conversiones activas',
            massivePayments: 'Pagos masivos',
            logout: 'Cerrar sesión',
            version: 'Versión',
            allRightsReserved: 'Todos los derechos reservados',
            forwardTime: 'Los futuros solo se procesan de 9 a.m. a 2 p.m. (CDMX, GMT-6) por horario bancario',
            payForwardDescriptionDisabled: 'Los futuros solo se procesan de 9 a.m. a 2 p.m. (CDMX, GMT-6) por horario bancario',
            bankingTime: 'Horario CDMX, GMT-6',
            localTime: 'Horario local',
            createAlerts: 'Crear alerta de precio',
            priceAlerts: 'Alertas de precio',
            createAlert: 'Crear alerta',
            notifyMeToSellUSD: 'Notificarme cuando el precio de USD llegue a',
            targetPrice: 'Precio objetivo',
            alertCancel: 'Cancelar',
            alertCreate: 'Crear',
        },
        invoices: {
            title: 'Facturas pendientes',
            subTitle: 'Aqui encontraras tus facturas que aun no se ha bloqueado el tipo de cambio y que estan pendientes de asignarse.',
            exchangeRateActual: 'Tipo de cambio actual',
            exchangeRateTodayDescription: 'Tipo de cambio se actualizará en',
            seconds: 'segundos',
            invoicePendingToAssign: 'Facturas pendientes de asignar',
            selectSupplier: 'Selecciona el beneficiario',
            selectClient: 'Selecciona el cliente',
            selectStatus: 'Selecciona el estatus',
            addInvoice: 'Agregar factura',
            pay: 'Pagar',
            collect: 'Cobrar',
            convert: 'Convertir',
            supplier: 'Beneficiario',
            client: 'Cliente',
            purchaseDate: 'Fecha de compra',
            salesDate: 'Fecha de venta',
            dueDate: 'Fecha de vencimiento',
            invoice: 'Factura',
            status: 'Estado',
            avaible: 'Pago disponible',
            totalAmountMXN: 'Monto dest total',
            totalAmountUSD: 'Monto origen total',
            totalCurrencyGain: 'Total de ganancias',
            rateProtection: 'Protección de tipo de cambio',
            profitPercentage: 'Beneficio de moneda (%)',
            currencyGain: 'Ganancia de moneda',
            actions: 'Acciones',
            selectId: 'Buscar factura',
            //Add invoice
            addInvoice: 'Agregar factura',
            addInvoiceDetail: 'Ingresa la siguiente información para agregar una nueva factura.',
            invoice: 'Factura',
            supplier: 'Beneficiario',
            purchaseDate: 'Fecha de compra',
            salesDate: 'Fecha de venta',
            totalAmountMXN: 'Total monto MXN',
            creditTime: 'Tiempo del credito',
            exchangeRateProtected: 'Tipo de cambio protegido',
            requiredField: '*indica campo requerido',
            paymentDetail: 'Detalle de pago',
            collectDetail: 'Detalle de cobro',
            customerName: 'Nombre del beneficiario',
            clientName: 'Nombre del cliente',
            clabe: 'Número CLABE',
            amountToSend: 'Cantidad a enviar',
            destinationReceives: 'El destinatario recibirá',
            exchangeRate: 'Tipo de cambio',
            invoiceToPay: 'Factura a pagar',
            invoiceToCollect: 'Factura a cobrar',
            sendDate: 'Fecha de envío',
            selectTypeConversion: 'Selecciona el tipo de conversión',
            selectTypeOfWallet: 'Selecciona la wallet desde donde quieres que salgan los fondos.',
            selectTypeOfWalletPay: 'Selecciona la wallet desde la que desea utilizar los fondos.',
            selectTypeOfCollect: 'Selecciona el destino donde quieres que se vayan los fondos.',
            conversionDetail: 'Detalle de la conversión',
            invoiceToConvert: 'Factura a convertir',
            amountToReceive: 'Cantidad a recibir en tu cuenta',
            exchangeRate: 'Tipo de cambio',
            convert: 'Convertir',
            selectDate: 'Selecciona la fecha de tu Futuro',
            forwardDetail: 'Detalle del Futuro',
            forwardConditions: 'Al programar un Futuro tienes que cumplir con las siguientes dos condiciones:',
            forwardConditions1: 'La fecha seleccionada es la fecha en la cual se ejecutará el pago pactado. La carga de fondos debe efectuarse previo al fin del plazo.',
            forwardConditions2: 'Tendrás que hacer un depósito del 5% de los fondos totales del Futuro, los cuales serán restados de tu balance USD.',
            forwardConditions6: 'Necesitarás disponer el 5% de los fondos totales del Futuro ahora, el monto a depositar es de',
            forwardConditions7: 'el monto se restará de tu balance USD',
            amountToSend: 'Cantidad a enviar',
            sendDate: 'Fecha programada',
            invoiceToConvert: 'Factura a convertir',
            amountToReceive: 'Cantidad a recibir en tu cuenta',
            exchangeRate: 'Tipo de cambio',
            convert: 'Convertir',
            forwardConditions3: 'Por favor carga los fondos correspondientes antes o en la fecha del vencimiento',
            forwardConditions4: 'Si el pago no cuenta con los fondos para la fecha indicada',
            forwardConditions5: 'En caso de no cumplir con el pago de la operación pactada, se deberá cubrir el diferencial entre la tipo de cambio de esa fecha y la pactada inicialmente.',
            download: 'Descargar',
            editInvoice: 'Editar factura',

            invoiceDeleteTitle: '¿Estás seguro de que deseas eliminar esta factura?',
            invoiceDeleteMessage: 'Una vez que eliminas la factura no podras recuperarla.',
            sId: "Orden de compra",
            invoiceDuplicateTitle: 'Aviso importante',
            invoiceDuplicateSubtitle: 'Se encontro una invoice similar a la que intentas agregar, ¿Deseas continuar?',
            amountError: 'El monto debe ser mayor al 5% del monto total.',
        },
        conversions: {
            title: 'Conversiones disponibles',
            avaibleConversion: 'Conversion disponible',
            description: 'Aqui encontraras tus conversiones disponibles para ejecutar pagos.',
            balance: 'Balance MXN',
            avaible: 'Monto disponible',
            assigned: 'Monto convertido',
            totalCurrencyGain: 'Total de ganancias',
            pay: 'Pagar',
            collect: 'Cobrar',
            id: 'Id',
            transactionDate: 'Fecha de transacción',
            typeTransaction: 'Tipo de transacción',
            targetAccount: 'Cuenta destino',
            dueDate: 'Fecha de vencimiento',
            missingDays: 'Días faltantes',
            totalAmountUSD: 'Monto total USD',
            totalAmountMXN: 'Monto total MXN',
            exchangeRate: 'Tipo de cambio',
            invoice: 'Factura',
            supplier: 'Nombre del beneficiario',
            purchaseDate: 'Fecha de compra',
            currencyProfit: 'Ganancia de moneda',
            dollarProfit: 'Ganancia de moneda',
            actions: 'Acciones',
            percentAssigned: '% Asignado',
            selectContact: 'Selecciona el contacto al que quieres enviar el pago.',
            contacts: 'Contactos',
            paymentDetail: 'Detalle de pago',
            collectDetail: 'Detalle de cobro',
            clientName: 'Nombre del cliente',
            clabe: 'Nmero CLABE',
            amountToSend: 'Cantidad a enviar',
            destinationReceives: 'El destinatario recibirá',
            exchangeRate: 'Tipo de cambio',
            invoiceToPay: 'Factura a pagar',
            invoiceToCollect: 'Factura a cobrar',
            sendDate: 'Fecha de envío',
            paymentConcept: 'Concepto de pago',
            detail: 'Detalle de la conversión',

            conversionDetailTitle: 'Detalle de la conversión',
            conversionDetailSubTitle: 'Aqui encontraras el detalle de la conversión de la factura seleccionada.',
            conversionDetailType: 'Tipo',
            conversionDetailAmount: 'Monto',
            conversionDetailProfit: 'Ganancia',
            conversionDetailProvider: 'Beneficiario',
            conversionDetailExchangeRate: 'Tipo de cambio',
            conversionDetailDate: 'Fecha de creación',
            conversionDetailDateEnd: 'Fecha de cumplimiento',
            conversionDetailPercent: 'Porcentaje de la conversión utilizado',
            conversionDetailInvoices: 'Facturas asignadas',
            conversionDetailSupplier: 'Nombre del beneficiario',
            conversionDetailAddInvoices: 'Agregar facturas',
            conversionDetailInvoice: 'Factura',
            conversionDetailEditInvoice: 'Modificar factura',
            conversionDetailDeleteInvoice: 'Eliminar factura de la conversión',
            conversionDetailPurchaseDate: 'Fecha de compra',
            conversionDetailExchangeRateProtected: 'Tipo de cambio protegido',
            conversionDetailConfirmPayment: '¿Estás seguro de que deseas solicitar el pago total del forward?',
            conversionDetailMessage: 'Una vez que realizas la transacción se revisará que tu saldo USD sea suficiente para pagar el total del forward.',
            conversionDetailMessage2: 'El monto se irá a la pestaña de saldo disponible MXN.',
            editForward: 'Editar forward',
            requestPayment: 'Solicitar pago',
            payInvoices: 'Pagar facturas',
            paymentDate: 'Fecha de pago',
            cobroDate: 'Fecha de cobro',
            recipient: 'Destinatario',
            client: 'Cliente',
            download: 'Descargar',
            status: 'Estado del pago',
        },
        activeForwards: {
            title: 'Conversiones activas',
            subTitle: 'Aqui encontraras tus forwards activos de que estan pendientes de realizarse.',
            usdBalance: 'Balance USD',
            blockedAmount: 'Monto bloqueado forwards',
            totalCurrencyGain: 'Total de ganancias',
            dueDate: 'Fecha de vencimiento',
            missingDays: 'Días faltantes',
            totalAmountUSD: 'Monto total USD',
            totalAmountMXN: 'Monto total MXN',
            exchangeRate: 'Tipo de cambio',
            currencyProfit: 'Ganancia de moneda',
            supplier: 'Beneficiario',
            actions: 'Acciones',
            invoice: 'Factura',
            purchaseDate: 'Fecha de compra',
            currencyProfit: 'Ganancias de moneda',
            dollarProfit: 'Ganancia de moneda',
            id: 'Id',
            transactionDate: 'Fecha de transacción',
            typeTransaction: 'Tipo de transacción',
            targetAccount: 'Cuenta destino',
            conversionDetailTitle: 'Detalle de la conversión',
            conversionDetailSubTitle: 'Aqui encontraras el detalle de la conversión de la factura seleccionada.',
            conversionDetailType: 'Tipo',
            conversionDetailAmount: 'Monto',
            conversionDetailProfit: 'Ganancia',
            conversionDetailProvider: 'Beneficiario',
            conversionDetailExchangeRate: 'Tipo de cambio',
            conversionDetailDate: 'Fecha de creación',
            conversionDetailDateEnd: 'Fecha de cumplimiento',
            conversionDetailPercent: 'Porcentaje de la conversión utilizado',
            conversionDetailInvoices: 'Facturas asignadas',
            conversionDetailSupplier: 'Nombre del beneficiario',
            conversionDetailAddInvoices: 'Agregar facturas',
            conversionDetailInvoice: 'Factura',
            conversionDetailEditInvoice: 'Modifiwcar factura',
            conversionDetailDeleteInvoice: 'Eliminar factura de la conversión',
            conversionDetailPurchaseDate: 'Fecha de compra',
            conversionDetailExchangeRateProtected: 'Tipo de cambio protegido',
            conversionDetailConfirmPayment: '¿Estás seguro de que deseas solicitar el pago total del forward?',
            conversionDetailMessage: 'Una vez que realizas la transacción se revisará que tu saldo USD sea suficiente para pagar el total del forward.',
            conversionDetailMessage2: 'El monto se irá a la pestaña de saldo disponible MXN.',
            editForward: 'Editar forward',
            requestPayment: 'Solicitar pago',
            download: 'Descargar',
            purchaseOrder: 'Orden de compra',
            forwardsAmountPendingGood: 'No tienes forwards pendientes de ejecutar en los próximos 5 días',
            forwardsAmountPendingAlert: 'Tienes forwards pendientes de ejecutar en los próximos 5 días, el monto total es de: ',
            amountRemainingUSD: 'Monto restante',
        },
        conversionsHistory: {
            title: 'Historial de conversiones',
            subTitle: 'Aqui encontraras el historial de todas tus conversiones realizadas.',
            totalCurrencyGain: 'Total de ganancias',
            viewDetail: 'Ver detalle',
            download: 'Descargar',
            detail: 'Detalle de conversión',
            type: 'Tipo',
            amount: 'Monto',
            exchangeRate: 'Tipo de cambio',
            creationDate: 'Fecha de creación',
            completionDate: 'Fecha de cumplimiento',
            percentageConversionPaid: 'Porcentaje de conversión pagado',
            payments: 'Pagos realizados',
            paymentDate: 'Fecha de pago',
            cobroDate: 'Fecha de cobro',
            recipient: 'Destinatario',
            invoice: 'Factura',
            noPayments: 'No hay pagos realizados',
            percentageConversionUsed: 'Porcentaje de conversión utilizado',
            invoicesAssigned: 'Facturas asignadas',
            invoiceDetail: 'Detalle de la factura',
            purchaseDate: 'Fecha de compra',
            exchangeRateProtected: 'Tipo de cambio protegido',
            profitPercent: 'Profit (%)',
            profit: 'Profit',
            noInvoicesAssigned: 'No hay facturas asignadas',
        },
        paymentsHistory: {
            title: 'Historial de egresos',
            subTitle: 'Aqui encontraras el historial de todos tus pagos realizados.',
            totalCurrencyGain: 'Total de ganancias',
            viewDetail: 'Ver detalle',
            download: 'Descargar',
            invoices: 'Facturas',
        },
        suppliers: {
            title: 'Beneficiarios',
            subTitle: 'Aqui podras administrar todos tus beneficiarios.',
            addSupplier: 'Agregar beneficiario',
            addClient: 'Agregar cliente',
            name: 'Nombre',
            entityBusiness: 'Tipo de entidad',
            entityBusinessCompany: 'Empresa',
            entityBusinessPerson: 'Persona',
            firstName: 'Nombre',
            lastName: 'Apellido',
            email: 'Correo',
            country: 'Pais',
            bankName: 'Nombre de banco',
            currencyAccount: 'Divisa de cuenta',
            accountNumber: 'Número de clabe',
            taxId: 'RFC',
            actions: 'Acciones',
            editSupplier: 'Editar beneficiario',
            deleteSupplier: 'Eliminar beneficiario',
            detailSupplier: 'Detalle de contacto',
            //Crear Beneficiario
            createSupplier: 'Crear beneficiario',
            createClient: 'Crear cliente',
            details: 'Ver detalles',
            requiredField: '*indica un campo obligatorio',
            //Editar Beneficiario
            editSupplier: 'Editar beneficiario',
            download: 'Descargar'
        },
        clients: {
            title: 'Clientes',
            subTitle: 'Aqui podras administrar todos tus clientes.',
            addSupplier: 'Agregar Cliente',
            addClient: 'Agregar cliente',
            name: 'Nombre',
            email: 'Correo',
            country: 'Pais',
            bankName: 'Nombre de banco',
            accountNumber: 'Número de clabe',
            taxId: 'RFC',
            actions: 'Acciones',
            editSupplier: 'Editar cliente',
            deleteSupplier: 'Eliminar cliente',
            //Crear Beneficiario
            createClient: 'Crear cliente',
            requiredField: '*indica un campo obligatorio',
            //Editar Beneficiario
            editSupplier: 'Editar cliente',
            download: 'Descargar'
        },
        settings: {
            title: 'Hola ',
            subtitle: 'Asegura tu cuenta. Administra la configuración de tu cuenta y define roles de usuario',

            emailTwoFactor: {
                title: 'Autenticación de dos factores',
                subtitle: 'Manten segura tu cuenta y proteger tu dinero. Ingresa tu nuevo correo para proteger tu cuenta con 2FA.',
                buttonText: 'Configurar',
                editEmailTitle: 'Actualizar correo electrónico',
                editEmailSubtitle: 'Ingresa tu nuevo correo electrónico para proteger tu cuenta con 2FA.',
                currentEmail: 'Correo electrónico actual',
                newEmail: 'Correo electrónico nuevo',
                cancel: 'Cancelar',
                continue: 'Continuar',
                configureEmailTitle: 'Configurar correo electrónico',
                configureEmailSubtitle: 'Ingresa tu nuevo correo electrónico para proteger tu cuenta con 2FA.',
                configureEmailEmail: 'Correo electrónico',
                configureEmailPassword: 'Contraseña actual',
                configureEmailSave: 'Guardar',
                twoFactor: {
                    title: 'Autenticación de dos factores',
                    subtitle: 'Hemos enviado un código a tu correo anterior. Ingrésalo para continuar.',
                    validate: 'Validar',
                    cancel: 'Cancelar',
                }
            },
            resetPassword: {
                title: 'Restablecer contraseña',
                subtitle: 'Para reestablecer tu contraseña, necesitas ingresar el codigo de verificación que te enviaremos a tu correo.',
                buttonText: 'Restablecer contraseña',
                resetPasswordTitle: 'Restablecer contraseña',
                resetPasswordSubtitle: 'Ingresa tu nueva contraseña y confírmala para continuar.',
                resetPasswordNewPassword: 'Nueva contraseña',
                resetPasswordConfirmPassword: 'Confirmar contraseña',
                continue: 'Continuar',
                cancel: 'Cancelar',
                twoFactor: {
                    title: 'Autenticación de dos factores',
                    subtitle: 'Por favor, ingresa el código de 6 dígitos que se ha enviado a tu email para confirmar la transacción. El código expirará en 10 minutos.',
                    validate: 'Validar',
                    cancel: 'Cancelar',
                }
            },
            users: {
                title: 'Usuarios',
                subtitle: 'Administra y crea nuevos usuarios para tu cuenta.',
                buttonText: 'Administrar',
                name: 'Nombre',
                lastname: 'Apellido',
                email: 'Correo',
                status: 'Estatus',
                actions: 'Acciones',
                edit: 'Editar',
                delete: 'Eliminar',
                addUser: 'Agregar usuario',
                active: 'Activo',
                inactive: 'Inactivo',
                disableUserTooltip: 'Desactivar usuario',
                confirmDeleteTitle: '¿Estás seguro que deseas deshabilitar al usuario?',
                confirmDeleteText: 'Una vez deshabilitado el usuario no podrá acceder a la plataforma.',
                confirmDeleteCancel: 'Cancelar',
                confirmDeleteDisable: 'Deshabilitar',
                password: 'Contraseña',
                confirmPassword: 'Confirmar contraseña',
                continue: 'Continuar',
                cancel: 'Cancelar',
                validate: 'Validar',
                otpTitle: 'Autenticación de dos factores',
                otpDescription: 'Por favor, ingresa el código de 6 dígitos que se ha enviado a tu email para confirmar la transacción. El código expirará en 10 minutos.',
                nameRequired: 'El nombre es requerido',
                lastnameRequired: 'El apellido es requerido',
                emailRequired: 'El correo es requerido',
                emailValid: 'El correo no es válido',
                passwordRequired: 'La contraseña es requerida',
                passwordLength: 'La contraseña debe tener al menos 6 caracteres',
                passwordSpecialCharacters: 'La contraseña debe tener al menos un carácter especial',
                otpRequired: 'El código de verificación es requerido',
                otpLength: 'El código de verificación debe tener 6 dígitos',
                confirmPasswordRequired: 'La confirmación de contraseña es requerida',
                confirmPasswordMatch: 'La confirmación de contraseña no coincide',
            },
            accountStatement: {
                title: 'Estado de cuenta',
                subtitle: 'Aqui encontraras tus estados de cuenta disponibles.',
                buttonText: 'Solicitar',
            }
        },
        incomes: {
            id: 'ID',
            sPayerName: 'Payer name',
            title: 'Historial de ingresos',
            subTitle: 'Aqui encontraras el historial de todos tus ingresos realizados.',
            download: 'Descargar',
            incomeDate: 'Fecha de ingreso',
            amountUsd: 'Monto USD',
        },
        statements: {
            title: 'Estado de cuenta',
            month: 'Mes',
            subtitle: 'Aqui encotraras tus estados de cuenta disponibles.',
        },
        calendars: {
            title: 'Calendarios',
            subtitle: 'Administra tus fechas de vencimiento de pagos.'
        }
    }
};

export default texts;
